import React from "react";

import { Caption } from "@olist/design-system";

import { CommentContainer, CommentWrapper } from "./styles";
import { Logo, UserTicker } from "icons/index";

interface IComment {
  type: "user" | "support";
  text: React.ReactNode;
  id: string | false;
  date?: string | null;
  contact_email?: string;
}

export function Comment({
  contact_email,
  date,
  id: idProp,
  text,
  type,
}: IComment) {
  const id = idProp || "";

  if (type === "support") {
    return (
      <CommentContainer id={id}>
        <img src={Logo} alt="support_logo" />
        <CommentWrapper>
          <Caption bold>Suporte Olist</Caption>
          <Caption>{date}</Caption>
          {text}
        </CommentWrapper>
      </CommentContainer>
    );
  }

  return (
    <CommentContainer id={id}>
      <img src={UserTicker} alt="user-ticket" />
      <CommentWrapper>
        <Caption bold>{contact_email}</Caption>
        <Caption>{date}</Caption>
        {text}
      </CommentWrapper>
    </CommentContainer>
  );
}
